export default {"src":"/_next/static/media/0xe3520349f477a5f6eb06107066048508498a291b.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};